import { DataType, Validator } from 'breeze-client';

const notEmptyGuidValidator = new Validator('notEmptyGuid', value => value !== DataType.Guid.defaultValue, {
  messageTemplate: "'%displayName%' must not be empty"
});

export { notEmptyGuidValidator };
